import { lazy } from 'react';

import isDesktop from 'helpers/isDesktop';
import withSuspense from 'helpers/withSuspense';

export default withSuspense(
  lazy(() => (isDesktop ? import('./index.desktop') : import('./index.mobile'))),
);
